<template>
  <slotted-edit-list-item :label="label"
                          :keyname="keyname"
                          :value="value"
                          :edit="edit"
                          :valuetext="valueText"
                          :valuecolor="valueColor"
                          :onlyedit="onlyedit"
                          :loading="loading">
    <template v-slot:editmodecontent>
      <normal-mode-template :label="label"
                            :value="editValue"
                            :valuetext="valueText"
                            :valuecolor="valueColor"
                            :loading="loading">
      </normal-mode-template>
      <v-list-item-action>
        <v-switch v-model="editValue"
                  hide-details
                  class="pa-0 ma-0" />
      </v-list-item-action>
    </template>
  </slotted-edit-list-item>
</template>


<script>
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";

export default {
  name: "SwitchEditListItem",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    keyname: String,
    value: Boolean,
    edit: [String, Boolean],
    onlyedit: [String, Boolean],
    loading: Boolean,
  },
  components: { SlottedEditListItem, NormalModeTemplate },

  data() {
    return { editValue: null };
  },

  mounted() {
    this.getBool();
  },

  methods: {
    getBool() {
      this.editValue = this.value === true;
    },
  },

  computed: {
    valueColor() {
      return this.editValue ? "primary" : "tertiary";
    },

    valueText() {
      return this.editValue
        ? this.$t("servicesystem.common_objects.commonterms.yes")
        : this.$t("servicesystem.common_objects.commonterms.no");
    },
  },

  watch: {
    editValue: function () {
      this.$emit("change", this.editValue);
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },

    value: function () {
      this.getBool();
    },

    edit: function () {
      if (this.edit) {
        this.getBool();
      }
    },
  },
};
</script>

<style scoped>
</style>